/**
 * Simulateurs réservés aux internes — chantier Booster (plan validé :
 * `docs/plans/booster-creation-simulatorid.md`, décision Q1 option A du 19/10/2026).
 *
 * Un simulateur marqué `internalOnly` (colonne `simulators.internal_only`) n'est visible et
 * lançable que par les profils internes ADM et COO : il est retiré de `GET /api/agents`, refusé
 * au lancement et absent de la configuration des packs pour tout autre profil. Règle générique :
 * Booster aujourd'hui, les futurs simulateurs managers ensuite (cible finale à étudier : les
 * managers des entreprises clientes, cf. spec/booster-routage-code-contextes-sideband.md § 2 bis).
 *
 * Un simulateur interne est en principe aussi DÉSACTIVÉ (les automatismes — Premium Zoho, accès aux
 * coachs, Plan, recommandations — ignorent les simulateurs désactivés) ; les internes peuvent
 * malgré tout l'utiliser dans les écrans (`simulateurUtilisable`). Les autres simulateurs
 * désactivés restent grisés pour tous.
 *
 * Fichier PARTAGÉ client + serveur : aucune dépendance.
 */

export const PROFILS_INTERNES_SIMULATEURS = ["ADM", "COO"] as const;

interface SimulateurReservable {
  internalOnly?: boolean | null;
  isActive?: boolean | null;
}

/** Le profil voit-il les simulateurs réservés aux internes ? */
export function voitSimulateursInternes(profileType: string | null | undefined): boolean {
  return !!profileType && (PROFILS_INTERNES_SIMULATEURS as readonly string[]).includes(profileType);
}

/** Le simulateur est-il visible (et lançable) pour ce profil ? Sans profil (sans connexion) : non s'il est interne. */
export function simulateurVisiblePour(simulateur: SimulateurReservable, profileType: string | null | undefined): boolean {
  return simulateur.internalOnly !== true || voitSimulateursInternes(profileType);
}

/**
 * Un simulateur d'une liste servie par `GET /api/agents` peut-il être choisi dans les écrans (cartes,
 * création de cas) ? Actif, ou réservé aux internes : le serveur ne sert un simulateur interne
 * qu'aux internes, qui peuvent ainsi jouer Booster bien qu'il soit désactivé. Les autres
 * simulateurs désactivés restent grisés pour tous.
 */
export function simulateurUtilisable(simulateur: SimulateurReservable): boolean {
  return simulateur.isActive !== false || simulateur.internalOnly === true;
}
